(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
        typeof define === 'function' && define.amd ? define(factory) :
            (global = global || self, (global.FullCalendarLocales = global.FullCalendarLocales || {}, global.FullCalendarLocales.sl = factory()));
}(this, function () {
    'use strict';

    var sl = {
        code: "sl",
        week: {
            dow: 1,
            doy: 7 // The week that contains Jan 1st is the first week of the year.
        },
        buttonText: {
            prev: "Prejšnji",
            next: "Naslednji",
            today: "Danes",
            month: "Mesec",
            week: "Teden",
            day: "Dan",
            list: "Seznam"
        },
        weekLabel: "Teden",
        allDayText: "Celi dan",
        eventLimitText: "več",
        noEventsMessage: "Ni rezultatov"
    };

    return sl;

}));